module.exports = __webpack_public_path__ + "static/media/sbp-logo-btn-light.17e53010.svg";